import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import s from './RequestsHistory.module.scss';
import { useOutletContext } from 'react-router-dom';
import { Modal } from 'components/common/Modal/Modal';
import { useTranslation } from 'react-i18next';

export const RequestsHistory = () => {
  const { t } = useTranslation();
  const { goBack, closeRouteModal } =
    useOutletContext<ModalNavigationContext>();

  return (
    <Modal
      title={t('profile.pricesAndOperations.requestsHistory')}
      onBack={goBack}
      onClose={closeRouteModal}
    >
      <div className={s.container}></div>
    </Modal>
  );
};
